export const downloadFileInBrowser = (blob: IBlob, type: string, fileName: string = 'file') => {
    const file = new Blob([blob], { type: type || blob.type })
    const element = document.createElement('a')
    element.href = URL.createObjectURL(file)
    element.download = fileName
    document.body.appendChild(element)
    element.click()
}
